import { jsxs as o, Fragment as s, jsx as e } from "react/jsx-runtime";
import { useState as d, useEffect as p } from "react";
import { CheckIcon as u } from "@systemeio/ui/icons";
import { FormInputUrl as f } from "@systemeio/ui";
import { ToolbarButton as n } from "../../components/content-controls/toolbar-button.mjs";
import { getToolbarIconClassName as i } from "../../constants/default-styles.mjs";
import h from "../../icons/download-icon.mjs";
import k from "../../icons/edit-icon.mjs";
import x from "../../icons/link-unset-icon.mjs";
import { isValidUrl as b } from "@systemeio/util";
function U({ href: r, unsetLink: t, setIsEditing: l }) {
  return /* @__PURE__ */ o(s, { children: [
    /* @__PURE__ */ e("div", { className: "w-[220px] truncate", children: /* @__PURE__ */ e("a", { href: r, target: "_blank", className: "text-brand-primary truncate px-3 underline", children: r }) }),
    /* @__PURE__ */ o("div", { className: "flex", children: [
      /* @__PURE__ */ e(n, { onClick: t, children: /* @__PURE__ */ e(x, { className: "main-transition-colors stroke-text-primary group-hover:stroke-red h-3.5 w-3.5" }) }),
      /* @__PURE__ */ e(n, { onClick: () => l(!0), children: /* @__PURE__ */ e(k, { className: i(!1) }) })
    ] })
  ] });
}
function j({
  initialValue: r,
  onSaveLink: t,
  openFileSelector: l
}) {
  const [a, c] = d(r);
  p(() => {
    c(r);
  }, [r]);
  const m = !b(a);
  return /* @__PURE__ */ o(s, { children: [
    /* @__PURE__ */ e(
      f,
      {
        className: "w-[250px]",
        value: a,
        placeholder: "example.com",
        onChange: c
      }
    ),
    /* @__PURE__ */ o("div", { className: "flex", children: [
      /* @__PURE__ */ e(n, { onClick: l, children: /* @__PURE__ */ e(h, { className: i(!1) }) }),
      /* @__PURE__ */ e(n, { type: "submit", onClick: () => t(a), disabled: m, children: /* @__PURE__ */ e(u, { className: i(m) }) })
    ] })
  ] });
}
export {
  j as LinkBubbleEdit,
  U as LinkBubbleView
};
